import { Injectable, OnDestroy} from '@angular/core';
import { UserDetailsService } from './user-details.service';
import {EmitterService} from './emitter.service'
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ZendeskService } from './zendesk.servcie';
import { FreshchatService } from './freshchat.service';
import { environment } from '../../environments/environment';

@Injectable()
export class Utilities implements OnDestroy {
  self: any;
  isProfileCompleted;
  userDetails;
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public userDetailsService: UserDetailsService,
    private emitterService:EmitterService,
    private zendeskService: ZendeskService,
    private freshChatService: FreshchatService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
    });

  }

  initChat(){
    if(environment.chatService == "zendesk"){
      this.zendeskService.initChat();
    } else if(environment.chatService == "freshChat"){
      this.freshChatService.initChat();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
